module.exports = __webpack_public_path__ + "static/media/calendar.e1f946d5.svg";